import { InputProps } from 'antd/lib/input';
import clsx from 'clsx';
import React from 'react';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';
const mask = ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
// Styled component để kế thừa style của Ant Design Input
// @ts-ignore
const StyledInput = styled(MaskedInput)`
  box-sizing: border-box;
  margin: 0;
  padding: 5px 16px;
  color: #1D2129;
  font-size: 18px;
  line-height: 2;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  border-radius: 5px;
  transition: all 0.2s;
  background: #ffffff;
  border-width: 1px;
  border-style: solid;
  border-color: #86909C;
  color: #232F3E;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 2;
  &:hover {
    border-color: #28c7c9;
    background-color: #ffffff;
  }
  &:focus, &:focus-within {
    border-color: #07b4bd;
    box-shadow: 0 0 0 2px rgba(255, 22, 105, 0.06);
    outline: 0;
    background-color: #ffffff;
  }

  &[aria-invalid="true"] {
    background: #ffffff;
    border-width: 1px;
    border-style: solid;
    border-color: #e31c3d;
  }
`;

const Container = styled.div`
  position: relative;
  .prefix-icon {
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding-left: 16px;
  }
  
  &.prefix input {
    padding-left: 60px;
  }
`;

// Props cho PhoneInput (kế thừa từ InputProps của Ant Design)
interface InputPhoneProps extends InputProps {
  mask?: Array<string | RegExp>; // Mask từ react-text-mask
  size?: InputProps['size'];
}
const InputPhone = React.forwardRef<HTMLInputElement, InputPhoneProps>(
  ({ value, onChange, className, prefix, ...rest }, _ref) => {
    return (
      <Container className={prefix ? 'prefix' : ''}>
        {prefix && <span className="prefix-icon">{prefix}</span>}
        {/* @ts-ignore */}
        <StyledInput
          {...rest}
          mask={mask}
          className={clsx('ant-input', className)}
          value={value as string}
          onChange={onChange}
          placeholder={rest.placeholder}
        />
      </Container>
    );
  }
);

InputPhone.displayName = 'InputPhone';

export default InputPhone;